'use strict';
var defineWellKnownSymbol = require('../internals/well-known-symbol-define');

// `Symbol.customMatcher` well-known symbol
// https://github.com/tc39/proposal-pattern-matching
defineWellKnownSymbol('customMatcher');



//////////////////
// WEBPACK FOOTER
// ./~/core-js-pure/modules/esnext.symbol.custom-matcher.js
// module id = 741
// module chunks = 13